import { render } from "./AwaitingReceivable.vue?vue&type=template&id=995da21c"
import script from "./AwaitingReceivable.vue?vue&type=script&lang=js"
export * from "./AwaitingReceivable.vue?vue&type=script&lang=js"

import "./AwaitingReceivable.vue?vue&type=style&index=0&id=995da21c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/AwaitingReceivable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "995da21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('995da21c', __exports__)) {
    api.reload('995da21c', __exports__)
  }
  
  module.hot.accept("./AwaitingReceivable.vue?vue&type=template&id=995da21c", () => {
    api.rerender('995da21c', render)
  })

}


export default __exports__